import { render, staticRenderFns } from "./AdminPanelDasboardQuiz.vue?vue&type=template&id=618e4fb9"
import script from "./AdminPanelDasboardQuiz.vue?vue&type=script&lang=js"
export * from "./AdminPanelDasboardQuiz.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports